import { createGlobalStyle } from 'styled-components';

const PostadGlobalStyles = createGlobalStyle`
  .h3__heading {
    padding-bottom: 25px;
  }
  .post__box {
    padding: 40px 30px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
    @media screen and (max-width: 768px) {
      padding: 30px 10px;
    }
    &.dashed {
      border-bottom: 1px dashed ${({ theme }) => theme.colors.Neutral[200]};
    }
    &:nth-last-child(2) {
      border-bottom: none;
    }
  }
  .postad__boxrow {
    margin-bottom: 30px;
    max-width: 432px;
    @media screen and (max-width: 768px) {
      max-width: 100%;
    }
  }
  .max__width {
    max-width: 432px;
    @media screen and (max-width: 768px) {
      max-width: 100%;
    }
  }
  .error__text {
    color: ${({ theme }) => theme.colors.Error};
  }
`;

export default PostadGlobalStyles;
